export default __webpack_public_path__ + "static/media/noimg.df431434.png";